import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../dynamicFormBuilder/FormField'
import {HeaderLayout} from '../Layout';

function HeaderTab(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;

    return (
              <FormField
                currrentUser={currentUser}
                layoutId='A017A536-2087-4A1F-B4AD-B82AB8DB4BEE'
                layoutName='OMTransactionprofileHeaderForm'
                defaultFormSchema={HeaderLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={props.handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={props.handleHeaderFormLoad}
                handleSelectedItemChange={props.handleSelectionChange}
            />);
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(HeaderTab);
